import { post, getDirectUrl } from "src/utils/http";

export const checkSpecialUser = async () => {
  const res = await post("/api/pblb-gateway/user/checkSpecialUser", {});
  const { mallId, isSpecialUser } = res || {};
  if (isSpecialUser) {
    return { username: "伪登录账号", mallId }; // TODO
  }
  return null;
};

// 检查登录状态
export const fetchLoginStatus = () => post("/mms-gateway/user/checkToken", {});

// 获取子系统 token
export const fetchSubToken = (accessToken: string) =>
  post("/mms-gateway/user/getToken", { accessToken, subSystemId: 3 });

// 退出登录
export const logout = async () => {
  const result = await post("/clint/api/logout", {});
  // if (result) {
  location.href = getDirectUrl();
  // }
  return result;
};

// 获取全部的文本
export interface IQueryAllKeyNameRequest {
  key: string;
}

export const queryAllKeyName = async (params: IQueryAllKeyNameRequest) => {
  const url = "/mmsapi/brandbank/dmp_common/key/name";
  const res: any = await post(url, params);
  if (!!res) {
    return res;
  }
  return {};
};

export const getWhiteList = async (options: {
  funcIds: number[];
}): Promise<{ [index: string]: boolean }> => {
  const res = await post("/mms-gateway/dmp/api/user/whiteList", options);
  const result: { [index: string]: boolean } = {};
  res.forEach((item: { funcId: string | number; white: boolean }) => {
    result[item.funcId] = item.white;
  });
  return result;
};

export const agreementSign = async () => {
  const res = await post("/mmsapi/brandbank/sign_agreement/sign", {});
  return res.sign_success;
};
